"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _websiteAppInitContext = require("./websiteAppInitContext");

var useWebsiteAppInitContext = function useWebsiteAppInitContext() {
  var _useContext = (0, _react.useContext)(_websiteAppInitContext.WebsiteAppInitContext),
      _useContext2 = (0, _slicedToArray2["default"])(_useContext, 2),
      state = _useContext2[0],
      setState = _useContext2[1];

  function updateConfigParameters(args) {
    var appConfigParameters = (0, _extends2["default"])({}, state.appConfigParameters, args);
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        appConfigParameters: appConfigParameters
      });
    });
  }

  function updateGeoLocation(args) {
    var geoLocation = (0, _extends2["default"])({}, state.geoLocation, args);
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        geoLocation: geoLocation
      });
    });
  }

  function updateClientWindowDimensions(args) {
    var clientWindowDimensions = (0, _extends2["default"])({}, state.clientWindowDimensions, args);
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        clientWindowDimensions: clientWindowDimensions
      });
    });
  }

  function updateDeviceInformation(args) {
    var clientDeviceInfo = (0, _extends2["default"])({}, state.clientDeviceInfo, args);
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        clientDeviceInfo: clientDeviceInfo
      });
    });
  }

  function updatePrivacyCookies(args) {
    var privacyCookies = (0, _extends2["default"])({}, state.privacyCookies, args);
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        privacyCookies: privacyCookies
      });
    });
  }

  function updateSiteCookiesList(args) {
    setState(function (state) {
      return (0, _extends2["default"])({}, state, {
        siteCookiesList: args
      });
    });
  }

  return {
    updateConfigParameters: updateConfigParameters,
    updateGeoLocation: updateGeoLocation,
    updateClientWindowDimensions: updateClientWindowDimensions,
    updateDeviceInformation: updateDeviceInformation,
    updatePrivacyCookies: updatePrivacyCookies,
    updateSiteCookiesList: updateSiteCookiesList,
    websiteAppInitContextState: state
  };
};

var _default = useWebsiteAppInitContext;
exports["default"] = _default;